// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { TypesaurusCoreDoc } from '@res/ngg-core';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { TransactionDef, TransactionRef, TransactionUpdateData } from '../../schema/schema.interface';
import { FirebaseError } from '@firebase/app';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace TransactionActions {
  export class GetAllTransaction {
    static readonly type = '[Transaction] GetAllTransaction';
    readonly type = GetAllTransaction.type;
  }

  export class InitTransactionsCount {
    static readonly type = '[Transaction] InitTransactionsCount';
    readonly type = InitTransactionsCount.type;
  }

  export class InitTransactions {
    static readonly type = '[Transaction] InitTransactions';
    readonly type = InitTransactions.type;
  }
  export class CountTransactions {
    static readonly type = '[Transaction] CountTransactions';
    readonly type = CountTransactions.type;
  }

  export class CloseTransactionsConnection {
    static readonly type = '[Transaction] CloseTransactionsConnection';
    readonly type = CloseTransactionsConnection.type;
  }

  export class GetTransactionById {
    static readonly type = '[Transaction] GetTransactionById';
    readonly type = GetTransactionById.type;
  }

  export class UpdateTransaction {
    static readonly type = '[Transaction] UpdateTransaction';
    constructor(
      public transactionData: Partial<TransactionUpdateData>,
      public ref: TransactionRef,
    ) {}
  }

  export class UpdateTransactionResult {
    static readonly type = '[Transaction] UpdateTransactionResult';
    constructor(public data: Array<TypesaurusCoreDoc<TransactionDef> | null | undefined>) {}
  }

  export class DeleteTransactions {
    static readonly type = '[Transaction] DeleteTransactions';
    constructor(public refs: TransactionRef[]) {}
  }

  export class PaginateQueryTransaction {
    static readonly type = '[Transaction] PaginateQueryTransaction';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public userId?: string,
    ) {}
  }
  export class TransactionError {
    static readonly type = '[Transaction] TransactionError';
    constructor(public error: Error | FirebaseError) {}
  }

  export class GetSumOf {
    static readonly type = '[Transaction] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Transaction] GetSumsCountOf';
    constructor(
      public fields: {
        name: string;
        sumId: { [keys: string]: string }[];
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public userId?: string,
    ) {}
  }
}
